import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AboutUsHeaderComponent } from '@content/about-us/about-us-header/about-us-header.component';
import { DividerImgComponent } from '@shared/divider-img/divider-img.component';
import { LocationComponent } from '@shared/location/location.component';
import { OurTeamComponent } from '@content/about-us/our-team/our-team.component';

@Component({
    selector: 'companyid-about-us',
    imports: [DividerImgComponent, LocationComponent, AboutUsHeaderComponent, OurTeamComponent],
    templateUrl: './about-us.component.html',
    styleUrl: './about-us.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutUsComponent {}
